<template lang="pug">
.d-flex.align-center.flex-wrap(style="gap: 8px")
  filter-date-picker(ref="date" :filter.sync="dateFilter")
  filter-panel(v-if="paymentType === 'panel'" ref="panel" :filter.sync="panelFilter" :panel-data.sync="localPanelData")
  v-spacer
  a.link-s.neutral500--text(v-if="allFilters.length > 0" @click="resetFilters") Reset filters
</template>

<script>
import FilterDatePicker from './FilterDatePicker.vue'
import FilterPanel from './FilterPanel.vue'

export default {
  name: 'InvoiceFilterRow',
  components: {
    FilterDatePicker,
    FilterPanel
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    paymentType: {
      type: String,
      default: 'self-pay'
    },
    panelData: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    dateFilter: {},
    panelFilter: {},
    localPanelData: null
  }),
  computed: {
    allFilters() {
      const filters = []
      // Handle date filter (may have 'between' key)
      if (this.dateFilter.key) {
        if (this.dateFilter.key === 'between') {
          filters.push(...this.dateFilter.value)
        } else {
          filters.push(this.dateFilter)
        }
      }
      // Handle panel filter (only for panel payment type)
      if (this.paymentType === 'panel' && this.panelFilter.key) {
        filters.push(this.panelFilter)
      }
      return filters
    }
  },
  watch: {
    allFilters(newValue) {
      this.$emit('update:filters', newValue)
    },
    localPanelData(newValue) {
      this.$emit('update:panelData', newValue)
    },
    paymentType() {
      this.resetFilters()
    }
  },
  methods: {
    resetFilters() {
      this.dateFilter = {}
      this.panelFilter = {}
      this.localPanelData = null
    }
  }
}
</script>

<style lang="scss" scoped>
.link-s {
  font-size: 14px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
</style>
